import { render, staticRenderFns } from "./cashPay.vue?vue&type=template&id=b2a3794c&scoped=true&"
import script from "./cashPay.vue?vue&type=script&lang=js&"
export * from "./cashPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a3794c",
  null
  
)

export default component.exports